import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "./index.css";

// Importar configuración de i18n ANTES de App
// Esto inicializa el sistema de traducciones
import "./lib/i18n";

// QueryClient configurado para la aplicación
import { queryClient } from "./lib/query-client";

import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* QueryClientProvider hace disponible el cache a toda la app */}
    <QueryClientProvider client={queryClient}>
      <App />
      {/* DevTools solo aparecen en desarrollo - botón flotante abajo a la izquierda */}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
);
